import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import Color from "../../../../assets/colors";

export const SectionTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "20px",
  lineHeight: "24px",
  marginBottom: "15px",
}));

export const AdditionalInfoTitle = styling(Typography)((props) => ({
  fontWeight: "700",
  fontSize: "16px",
  lineHeight: "24px",
}));

export const AdditionalInfoBody = styling(Typography)((props) => ({
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "22px",
  marginBottom: "10px",
}));

export const TypographyStyled = styling(Typography)((props) => ({
  //
}));

export const GridStyled = styling(Grid)((props) => ({
  //
}));

export const CompanyProfileBox = styling(Grid)((props) => ({
  border: `1px solid ${Color.grey}`,
  borderRadius: "8px",
  padding: "24px",
}));

export const ImageStyled = styling("img")((props) => ({
  objectFit: "contain",
  borderRadius: "8px",
  marginRight: "20px",
}));

export const ContainedButton = styling(LoadingButton)((props) => ({
  gap: "10px",
  textTransform: "capitalize",
  color: "rgba(255, 255, 255, 0.87)",
  fontSize: "16px",
  lineHeight: "19px",
  fontWeight: "700",
  padding: "15px 30px",
  borderRadius: "8px",
  minWidth: "150px",
  minHeight: "50px",
  backgroundColor: Color.buttonBlack,
  boxShadow: "none",

  "&:hover": {
    backgroundColor: Color.black,
    color: Color.white,
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const OutlinedButton = styling(Button)((props) => ({
  gap: "10px",
  textTransform: "capitalize",
  color: Color.black,
  fontSize: "0.875rem",
  lineHeight: "19px",
  fontWeight: "400",
  height: "48px",
  padding: "0 1rem",
  borderRadius: "8px",
  minWidth: "200px",
  backgroundColor: Color.white,
  border: `1px solid ${Color.black}`,

  transition: "box-shadow 0.1s ease-in-out, transform 0.1s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      backgroundColor: Color.white,
      border: `1px solid ${Color.black}`,
      boxShadow: "4px 4px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-4px, -4px)",
    },
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const LoadingIndicator = styling(CircularProgress)((props) => ({
  color: Color.error,
}));

export const LinkStyled = styling(Link)({
  textDecoration: "none",
  textTransform: "capitalize",
  display: "flex",
});
